import AgoraRTC from "agora-rtc-sdk"
import BaseEvent from "../../util/baseEvent"
import { getVideoSetting } from "../../util/getVideoSetting"
import { apiURL } from "@/config"
import axios from "axios"

let haspublishCall = false

class AgoraLiveCore extends BaseEvent {
  constructor() {
    super()
    this.$logger.setPrefix("agora")
  }
  enterRoom(authInfo) {
    this.client = null
    this.localStream = null
    let self = this
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: apiURL + "/api/vps/service/openclass/gslb/ec/createtoken",
        data: Object.assign({}, authInfo)
      })
        .then(res => {
          let { data } = res.data
          let { agora } = data
          AgoraRTC.Logger.setLogLevel(AgoraRTC.Logger.DEBUG)
          self.client = AgoraRTC.createClient({ mode: "interop" })
          self.client.init(agora.appId, function() {
            self.client.join(
              agora.channelKey,
              authInfo.roomId,
              authInfo.userId,
              function(uid) {
                self.initEvent()
                resolve({ status: 1, userid: uid })
              },
              function(err) {
                reject(new Error("连接房间出错" + err))
              }
            )
          })
        })
        .catch(err => {
          reject(new Error(err))
        })
    })
  }
  exitRoom() {
    haspublishCall = false
    return new Promise((resolve, reject) => {
      this.client.leave(
        function() {
          resolve({ status: 0 })
        },
        function(err) {
          reject(new Error(err))
        }
      )
    })
  }
  getDeviceList() {
    return new Promise((resolve, reject) => {
      AgoraRTC.getDevices(
        function(devices) {
          resolve(devices)
        },
        function(err) {
          reject(new Error(err))
        }
      )
    })
  }
  getMedialStream(config) {
    let self = this
    return new Promise((resolve, reject) => {
      if (!config.streamID) {
        config.streamID = self.userId
      }
      this.localStream = AgoraRTC.createStream(config)
      let setting = getVideoSetting(config.videoSize, config.videoFrameRate)

      console.log("=======config=====", { ...config })
      console.log("=======setting=====", setting)
      this.localStream.setVideoProfile(setting) // 设置屏幕分辨率
      this.localStream.init(
        function(res) {
          resolve(self.localStream)
        },
        function(err) {
          reject(new Error(err))
        }
      )
    })
  }
  getShowMedialStream(config) {
    let self = this
    return new Promise((resolve, reject) => {
      if (!config.streamID) {
        config.streamID = self.userId
      }
      let showStream = AgoraRTC.createStream(config)
      let setting = getVideoSetting(config.videoSize, config.videoFrameRate)
      showStream.init(
        function(res) {
          resolve(showStream)
        },
        function(err) {
          reject(new Error(err))
        }
      )
    })
  }
  publishMedialStream(stream) {
    let self = this

    return new Promise((resolve, reject) => {
      this.client.publish(stream || this.localStream, function(err) {
        if (err) self.warn("publish stream error " + err)
        reject(new Error(err))
      })
      console.log("-----------------", haspublishCall)
      if (haspublishCall) {
        resolve(stream || this.localStream)
        return
      }
      this.client.on("stream-published", evt => {
        haspublishCall = true
        // 老师发布流成功
        self.emit("STREAM_PUBLISHED", evt)
        resolve(evt)
      })
    })
  }
  unpublishMedialStream(stream) {
    let self = this

    return new Promise((resolve, reject) => {
      this.client.unpublish(stream || this.localStream, function(err) {
        if (err) {
          reject(new Error(err))
        }
      })
      setTimeout(() => {
        self.emit("STREAM_UNPUBLISHED", this.localStream)
        resolve(this.localStream)
      }, 200)
    })
  }
  playMedial(config) {
    let stream = config.stream || this.localStream
    return new Promise((resolve, reject) => {
      if (stream) {
        stream.play(config.videoId)
        resolve(stream)
      } else {
        reject(new Error("play failed"))
      }
    })
  }
  // playShowMedia(config,stream){
  //   return new Promise((resolve, reject) => {
  //     if (stream) {
  //       stream.play(config.videoId)
  //       resolve(stream)
  //     } else {
  //       reject(new Error("play failed"))
  //     }
  //   })
  // }
  closeMedial(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.stop()
      resolve("关闭流成功")
    })
  }
  enableVideo(stream) {
    // let self = this
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.unmuteVideo() || streamObj.enableVideo()
      resolve(streamObj)
    })
  }
  disableVideo(stream) {
    // let self = this
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.muteVideo() || streamObj.disableVideo()
      resolve(streamObj)
    })
  }
  enableAudio(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.unmuteAudio() || streamObj.enableAudio()
      resolve(streamObj)
    })
  }
  disableAudio(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.muteAudio() || streamObj.disableAudio()
      resolve(streamObj)
    })
  }
  subscribeMedialStream() {
    let self = this
    return new Promise((resolve, reject) => {
      self.client.subscribe(this.localStream, function(err) {
        reject("订阅失败")
      })
    })
  }
  getAudioLevel(stream) {
    let streamObj = stream || this.localStream
    return streamObj.getAudioLevel()
  }
  getStreamStats(stream) {
    return new Promise((resolve, reject) => {
      let streamObj = stream || this.localStream
      streamObj.getStats(stats => {
        resolve(stats)
      })
    })
  }
  getLocalStream() {
    return this.localStream
  }
  checkSystemRequirements() {
    return AgoraRTC.checkSystemRequirements
  }
  initEvent() {
    let self = this

    // 订阅音视频
    self.client.on("stream-added", function(evt) {
      let stream = evt.stream
      self.subscribeMedialStream(stream)
    })
    // 监听订阅
    self.client.on("stream-subscribed", function(evt) {
      self.localStream = evt.stream
      self.log("STREAM_PUBLISHED--------->")
      self.emit("STREAM_PUBLISHED", evt)
    })
    // 取消订阅音视频
    self.client.on("stream-removed", function(evt) {
      self.emit("STREAM_UNPUBLISHED", evt)
    })
    // 离开频道
    self.client.on("peer-leave", function(evt) {
      self.log("声网退出教室")
      self.emit("CLIENT_LEAVE", evt)
    })
    // 打开视频
    self.client.on("unmute-video", function(evt) {
      self.emit("VIDEO_OPEN", evt)
    })
    // 关闭视频
    self.client.on("mute-video", function(evt) {
      self.emit("VIDEO_CLOSE", evt)
    })
    // 打开音频
    self.client.on("unmute-audio", function(evt) {
      self.emit("AUDIO_OPEN", evt)
    })
    // 关闭音频
    self.client.on("mute-audio", function(evt) {
      self.emit("AUDIO_CLOSE", evt)
    })
  }
}
export default AgoraLiveCore
